var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "close_svg__Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 62 62"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".close_svg__cls-1{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_svg__close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_svg__close_line-tl-br",
    d: "m3 3 56 56",
    className: "close_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "close_svg__close_line-bl-tr",
    d: "M59 3 3 59",
    className: "close_svg__cls-1"
  })))));
};
export default SvgClose;